import React, { useState } from 'react';

const ChangeDescription = ({ onNext, answers, stepKey }) => {
  const [description, setDescription] = useState(answers[stepKey] || '');
  const [error, setError] = useState('');

  const handleContinue = () => {
    if (description.trim() === '' || description.length < 3) {
      setError('Please provide a description (at least 3 characters).');
    } else {
      setError('');
      onNext(description);
    }
  };
  const handleChange = (e) => {
    setDescription(e.target.value);
    if (error) {
      setError('');
    }
  };


  return (
    <>
      <div className="qs-card__head"><h2 className="qs-card__title">Please describe the change</h2></div>
      <div className="qs-card__body">
        <p className="qs-card__sub">(e.g., increase, decrease, reason, approximate date)</p>
        <textarea
          className="qs-textarea"
          placeholder="Explain here"
          value={description}
          onChange={handleChange}
        />
        {error && <p className="qs-error-message" style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
        <div className="qs-actions">
          <button 
            type="button" 
            className="qs-btn qs-btn--primary" 
            onClick={handleContinue}
          >Continue 
          <span className="qs-arrow">→</span>
          </button>
          </div>
      </div>
    </>
  );
};

export default ChangeDescription;
